import { ROTATION, ROTATION_START } from './rotation';

export const getCurrentRotation = () => {
    const today = new Date();

    // Find current Tuesday
    const daysSinceTuesday = (today.getDay() + 5) % 7; // Calculate days since last Tuesday
    const currentTuesday = new Date(today); // Set current Tuesday to today
    currentTuesday.setDate(today.getDate() - daysSinceTuesday); // Adjust to the most recent Tuesday
    currentTuesday.setHours(0, 0, 0, 0); // Set time to midnight for consistency

    const nextTuesday = new Date(currentTuesday); // Find next Tuesday
    nextTuesday.setDate(currentTuesday.getDate() + 7); // Find next Tuesday by adding 7 days to current 

    const msPerWeek = 7 * 24 * 60 * 60 * 1000; // miliseconds in a week
    const periodIndex = Math.floor(
        (currentTuesday - ROTATION_START) / msPerWeek
    ); // Calculate the period index since rotation start date

    const personIndex = ((periodIndex % ROTATION.length) + ROTATION.length) % ROTATION.length; // Calculate the index of the person in the rotation
    const fmt = (date) => date.toLocaleString('en-GB', { day: 'numeric', month: 'short' });

    return {
        people: ROTATION[personIndex],
        from: fmt(currentTuesday),
        to: fmt(nextTuesday),
    };
}